export default import.meta.ROLLDOWN_FILE_URL_Bp7suD4FlY0BAvMWIJaEGQ